import 'font-awesome/css/font-awesome.css';

import './assets/fonts/calibril.woff';

import './app.scss';
import './assets/styles/theme.scss';
import './assets/styles/globals.scss';

import './components/layout/layout-template.scss';
import './components/layout/layout-template.html';
import './components/layout/layout-template.ts';

//  -------- PAGES START -------- 

import './components/pages/home/home.html';
import './components/pages/home/home.ts';
import './components/pages/home/home.scss';

import './components/pages/our-story/our-story.html';
import './components/pages/our-story/our-story.ts';

import './components/pages/service/service.html';
import './components/pages/service/service.ts';

import './components/pages/articles/articles.html';
import './components/pages/articles/articles.ts';

import './components/pages/contact-us/contact-us.html';
import './components/pages/contact-us/contact-us.ts';
import './components/pages/contact-us/contact-us.scss';

//  -------- PAGES END -------- 

//  -------- SERVICE PAGES START -------- 
import 'components/pages/service/category/radioadvertising/radio-advertising.html';
import 'components/pages/service/category/radioadvertising/radio-advertising.ts';

import 'components/pages/service/category/digitalmarketing/digital-marketing.html';
import 'components/pages/service/category/digitalmarketing/digital-marketing.ts';

import 'components/pages/service/category/televisionadvertising/television-advertising.html';
import 'components/pages/service/category/televisionadvertising/television-advertising.ts';

import 'components/pages/service/category/influencers/influencers.html';
import 'components/pages/service/category/influencers/influencers.ts';

import 'components/pages/service/category/conceptualization/conceptualization.html';
import 'components/pages/service/category/conceptualization/conceptualization.ts';

import 'components/pages/service/category/podcasts/podcasts.html';
import 'components/pages/service/category/podcasts/podcasts.ts';

import 'components/pages/service/category/production/production.html';
import 'components/pages/service/category/production/production.ts';

import 'components/pages/service/category/publicrelations/public-relations.html';
import 'components/pages/service/category/publicrelations/public-relations.ts';

import 'components/pages/service/category/activations/activations.html';
import 'components/pages/service/category/activations/activations.ts';

import 'components/pages/service/category/workshopstraining/workshops-training.html';
import 'components/pages/service/category/workshopstraining/workshops-training.ts';

//  -------- SERVICE PAGES END -------- 

import './components/_common/submenu/sub-menu.html';
import './components/_common/submenu/sub-menu.ts';
import './components/_common/submenu/sub-menu.scss';
import './components/_common/mind-map/mind-map.scss';

import './components/_common/carousel/carousel.html';
import './components/_common/carousel/carousel.ts';
import './components/_common/carousel/carousel.scss';
